import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";

// Same as GetDashboardsCB's DashboardDTO plus the owner, since the list can belong to
// another user.
class DashboardWithOwnerDTO {
  id!: number;
  name!: string;
  enabled!: boolean;
  defaultDashboard!: boolean;
  ownerUserId!: number;
  ownerUsername!: string;
}

class O {
  dashboards!: DashboardWithOwnerDTO[];
}

/**
 * I Inner Class
 */
class I {
  // Omit for the authenticated user's own dashboards. A partition/system admin can pass the
  // id of another user of equal or lower role, within the partitions they are enabled on.
  userId?: number;
}

/**
 * Impersonation-aware counterpart of getDashboards, which stays self-only.
 */
export class GetAllUserDashboardsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.GetAllUserDashboards);
    this.i = new I();
    this.o = new O();
  }
}
